<span *ngIf="step">{{ step }}. </span>
<ng-content></ng-content>
